module.exports = __webpack_public_path__ + "static/media/studio-step1@3x.e9b75b02.webp";